angular.module('app').factory('topMatchesService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        restAngular = restAngular.all("/topmatchskin/");

        return {
            getList: function (requestData) {
                return restAngular.
                    one("get").
                    customGET(param(requestData))
            },
            deleteMatchById: function (requestData) {
                return restAngular.
                    one("delete").
                    customGET(param(requestData))
            },
            change: function (requestData) {
                return restAngular.
                    one("change").
                    post("", requestData)
            },
            create: function (requestData) {
                return restAngular.
                    one("create").
                    post("", requestData)
            }
        }
    }
]);